import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import { ReactComponent as SterlingLogoSvg } from "../../../assets/sterlingLogo.svg";
import { ReactComponent as DownloadIconSvg } from "../../../assets/downloadIcon.svg";
import { ReactComponent as DownloadSvg } from "../../../assets/download.svg";
import { ReactComponent as CloseSvg } from "../../../assets/close.svg";
import { ReactComponent as DocumentFileSvg } from "../../../assets/documenFile.svg";
import { ReactComponent as UploadIconSvg } from "../../../assets/uploadIcon.svg";
import { ReactComponent as UploadIconMiniSvg } from "../../../assets/uploadIconmini.svg";
import Modal from "../../../app/common/modals/Custom";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../app/stores/store";
import Loading from "../../../app/layout/Loading";
import { FileName } from "../../../app/models/terms";
import FileTemp from "../../../app/common/form/FileTemp";
import { toast } from "react-toastify";
import DOMPurify from "dompurify";

const TermsAndConditions = () => {
  const [openMOAModal, setOpenMOAModal] = useState(false);
  const [openVendorChecklistModal, setOpenVendorChecklistModal] =
    useState(false);
  const [openCACModal, setOpenCACModal] = useState(false);
  const [toggleCAC, setToggleCAC] = useState(true);
  const { commonStore, userStore } = useStore();
  const {
    downloadFile,
    loadingInitial,
    uploadCac,
    fetchCac,
    vendorCac,
    uploadFile,
  } = userStore;
  const { loggedInUser } = commonStore;
  const returnPolicy = process.env.REACT_APP_RETURN_POLICY;
  const [documentUpload, setDocumentUpload] = useState<string>("");
  const [documentName, setdocumentName] = useState("");

  const documentHandler = (e: any) => {
    // console.log(e);
    try {
      const UPLOAD_LIMIT = Number(process.env.REACT_APP_UPLOAD_LIMIT);
      if (isNaN(UPLOAD_LIMIT)) {
        toast.error("Upload limit not configured. Set REACT_APP_UPLOAD_LIMIT in .env");
        setDocumentUpload("");
        setdocumentName("");
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          const file = e.target.files && e.target.files[0];
          if (!file) return;
          if (file.size > UPLOAD_LIMIT) {
            const mb = UPLOAD_LIMIT / 1048576;
            toast.error(`File too large. Maximum upload size is ${mb} MB.`);
            setDocumentUpload("");
            setdocumentName("");
            return;
          }
          if (file.type !== "application/pdf") {
            const error = "File is not a pdf";
            setDocumentUpload("");
            setdocumentName("");
            toast.error(error);
            throw error;
          }
          setDocumentUpload(reader.result!.toString());
          setdocumentName(file.name);
        }
      };
      const file = e.target.files && e.target.files[0];
      if (file) reader.readAsDataURL(file);
    } catch {
      // console.log("none");
      setDocumentUpload("");
    }
  };
  const handleCacUpload = async (value: string) => {
    // console.log(value);
    await uploadFile(value)
      .then((res) => {
        // console.log(res);
        if (res.isSuccessful) {
          uploadCac(res.data)
            .then((res) => {
              if (res.isSuccessful) {
                setToggleCAC(true);
                fetchCac();
              } else {
                toast.error("Problem uploading File");
              }
            })
            .catch((err) => console.log(err));
        } else {
          toast.error("Problem uploading File");
        }
      })
      .catch((err) => console.log(err));
  };
  const handleFileDownload = async (value: string, fileName: FileName) => {
    const linkSource = `data:application/pdf;base64,${value}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = DOMPurify.sanitize(linkSource);
    downloadLink.download = fileName;
    downloadLink.click();
  };
  const handleFileUrlDownlaod = async (dataurl: string, fileName: FileName) => {
    const link = document.createElement("a");
    link.href = DOMPurify.sanitize(dataurl);
    link.download = fileName;
    link.click();
  };
  const downloadvalues = {
    firmSize:
      loggedInUser && loggedInUser.firmSize ? loggedInUser.firmSize : "",
    businessName:
      loggedInUser && loggedInUser.businessName
        ? loggedInUser.businessName
        : "",
    businessAddress:
      loggedInUser && loggedInUser.businessAddress
        ? loggedInUser.businessAddress
        : "",
    businessStructure:
      loggedInUser && loggedInUser.businessStructure
        ? loggedInUser.businessStructure
        : "",
    establishedYears:
      loggedInUser && loggedInUser.establishedYears
        ? loggedInUser.establishedYears
        : "",
    annualTurnover:
      loggedInUser && loggedInUser.annualTurnover
        ? loggedInUser.annualTurnover
        : "",
    percentTotalAnnualTurnOver:
      loggedInUser && loggedInUser.percentTotalAnnualTurnOver
        ? loggedInUser.percentTotalAnnualTurnOver
        : "",
    relevanceOfCVs:
      loggedInUser && loggedInUser.relevanceOfCVs
        ? loggedInUser.relevanceOfCVs
        : "",
    localPresences:
      loggedInUser && loggedInUser.localPresences
        ? loggedInUser.localPresences
        : "",
    noOfInstallationsDone:
      loggedInUser && loggedInUser.noOfInstallationsDone
        ? loggedInUser.noOfInstallationsDone
        : "",
    experienceNigeriaMarket:
      loggedInUser && loggedInUser.experienceNigeriaMarket
        ? loggedInUser.experienceNigeriaMarket
        : "",
    experienceSolarSystem:
      loggedInUser && loggedInUser.relevanceOfCVs
        ? loggedInUser.relevanceOfCVs
        : "",
    levelOfWarrantySolar:
      loggedInUser && loggedInUser.levelOfWarrantySolar
        ? loggedInUser.levelOfWarrantySolar
        : "",
    renewableEnergy:
      loggedInUser && loggedInUser.renewableEnergy
        ? loggedInUser.renewableEnergy
        : "",
    totalVendorPercentage:
      loggedInUser && loggedInUser.totalVendorPercentage
        ? loggedInUser.totalVendorPercentage
        : "",
  };
  useEffect(() => {
    fetchCac();
    // .catch();
  }, [fetchCac]);
  return (
    <div className={styles.page}>
      {loadingInitial === "loading" && <Loading />}
      <Modal
        variant="unstyled"
        openModal={openMOAModal}
        // closeModal={() => setOpenMOAModal(false)}
        style={{ position: "fixed" }}
      >
        <div
          className={styles.closeModal}
          onClick={() => setOpenMOAModal(false)}
        >
          <div className={styles.closeFlex}>
            <div className={styles.closeBox}>
              <div>
                <CloseSvg />
                <p>Close</p>
              </div>
            </div>
            <div
              className={styles.downloadBox}
              onClick={() => {
                downloadFile({
                  fileName: FileName.memorandum,
                  ...downloadvalues,
                })
                  .then((res) =>
                    handleFileDownload(res.data, FileName.memorandum)
                  )
                  .catch((e) => console.log(e));
              }}
            >
              <div>
                <DownloadSvg />
                <p>Download</p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.modal}>
          <div className={styles.termsfineprint}>
              <h1 className="text-3xl font-bold text-center mb-6">MEMORANDUM OF AGREEMENT</h1>

              <h2 className="text-2xl font-semibold text-center mb-4">BETWEEN</h2>
              <h2 className="text-2xl font-semibold text-center mb-4">THE ALTERNATIVE BANK</h2>
              <h2 className="text-2xl font-semibold text-center mb-8">AND</h2>

              <p className="mb-4">This Memorandum of Agreement (“Agreement”) is made the ………………………………………</p>

              <h3 className="text-xl font-semibold mb-4">BETWEEN</h3>
              <p className="mb-4">THE ALTERNATIVE BANK LIMITED a company incorporated under the laws of the Federal Republic of Nigeria, with its registered office at 239, Ikorodu Road, Lagos (hereinafter referred to as “the Bank” which expression shall where the context so permits include its successors in title and assigns) of the one part,</p>
              <p className="mb-4">AND</p>
              <p className="mb-4">{loggedInUser && loggedInUser.businessName} a company incorporated under the laws of the Federal Republic of Nigeria with its registered office at {" "}
              {loggedInUser && loggedInUser.businessAddress} (hereinafter referred to as “the Merchant or {" "}
              {loggedInUser && loggedInUser.businessName}” which expression shall where the context so permits include its successors in title and assigns) of the other part.</p>
              <p className="mb-6">The Bank and {loggedInUser && loggedInUser.businessName} shall collectively be referred to “as the parties” and individually as “the party”.</p>

              <h3 className="text-xl font-semibold mb-4">WHEREAS:</h3>
              <p className="mb-2">The Bank transacting through its Non-Interest Banking Window has created a platform known as ALTPOWER (the “Platform”), which connects Merchants to potential customers and provides access to credit facilities to merchants and customers desirous of purchasing renewable energy solutions from various merchants on the platform “the Objective”.</p>
              <p className="mb-2">The Partner is an authorized marketer of renewable energy solutions and services “the Products” and is desirous of displaying and selling its products and services on the Platform.</p>
              <p className="mb-6">The Parties have agreed to a collaboration where the Bank will onboard the Merchant to the Platform and provide credit facilities when required and the Merchant will provide and sell the Products to the Bank’s customers, subject to the terms and conditions stated hereunder.</p>

              <h3 className="text-xl font-semibold mb-4">NOW THIS AGREEMENT witnesses as follows:</h3>

              <h3 className="section-heading text-xl font-semibold">COMMENCEMENT AND DURATION:</h3>
              <p className="mb-6">This Agreement shall commence on the date above written and remain in force for an initial period of One (1) year, unless earlier terminated by either party in accordance with the provisions herein contained. This Agreement may be renewed for such further terms on conditions mutually agreed by the Parties.</p>

              <h3 className="section-heading text-xl font-semibold">SCOPE OF SERVICE</h3>
              <p className="mb-2">The Agreement is divided into 2 sections of services as follows:</p>
              <ul className="list-disc ml-6 mb-6">
                <li>Altpower Ecommerce Platform</li>
                <li>Quotations, Energy Audits, Award of Contracts, and Installation</li>
              </ul>

              <h3 className="section-heading text-xl font-semibold">PARTIES OBLIGATIONS: SCOPE OF SERVICES EXPANDED</h3>

              <h4 className="sub-section-heading text-lg font-semibold">SECTION A: ALTPOWER ECOMMERCE PLATFORM PARTIES OBLIGATIONS</h4>
              <p className="font-semibold mb-2">The Bank will:</p>
              <ul className="list-decimal ml-6 mb-4">
                <li>Manage and oversee the effective operation of the Platform with the objective of ensuring seamless transactions on the retail online shop for the renewable energy products.</li>
                <li>Ensure access to the Vendors to display its products and services on the Platform.</li>
                <li>Accept sales request on behalf of the Vendor and pass request to the Vendor with details of customer for ease of identification and delivery.</li>
                <li>Accept and manage receipt of reviews or complaints from customers and users of the Platform.</li>
                <li>Ensure payment is made to the Vendor within the specified time for every item/good purchased from the platform by customers.</li>
                <li>Provide financing where required by a customer/purchaser, subject to customer satisfying the Bank’s risk assessment and credit approval process.</li>
                <li>Receive and warehouse the price paid by the customers for purchase and installation of the product and credit the Vendor’s account with the Bank upon confirmation and the receipt of a job completion notification from the customer.</li>
                <li>Inform the Vendor of any adjustment to the repurchase price of the Products.</li>
              </ul>

              <p className="font-semibold mb-2">The Vendor shall:</p>
              <ul className="list-decimal ml-6 mb-4">
                <li>Ensure that it displays on the platform only products approved by the Bank “authorized products” with appropriate weight, dimension, and specifications. The display MUST include capacity, brand, type, quantity, warranty period. The display should not be limited to, a detailed title and sub-title, price, available services, pictures and description only. Any other useful information can be added to the display.</li>
                <li>Ensure that appropriate prices are attached to products displayed on the platform and that they are readily available in its store/warehouse for immediate delivery. Repeated stock-outs for two times consecutively, will result in the removal of the Vendor and all their products from the Platform.</li>
                <li>Notify the Bank of any changes to the detail of its listings while uploaded on the Platform.</li>
                <li>Log in to their Altpower store at least 2 times daily to update their product prices, inventory and process orders of all its products listed on the Platform.</li>
                <li>Provide a warranty to cover each of its product component.</li>
                <li>Ensure all invoices and product listings clearly state the brands of equipment and warranty provided on each equipment.</li>
                <li>Introduce its customers to the Altpower products offerings and refer such customer to the Bank for profiling and product financing.</li>
                <li>Open an account with the Bank for remittance of sale proceeds.</li>
                <li>Ensure that products ordered are dropped/shipped to designated drop-off locations within 48 hours after order placement, failing which order will be cancelled and replaced.</li>
                <li>Where installation is required, ensure that installation is completed within 48 hours of delivery of the products to the customer location. Installation timeline greater than 48 hours due to project size must be agreed by the parties before commencement.</li>
                <li>Accept return of products purchased within 7 days of delivery.</li>
                <li>Receive payment only after 7-day return policy timeline has elapsed for product purchased outrightly. Different payment terms apply to products sold under Lease to own and power-as-a-service.</li>
                <li>Keep and maintain a logbook containing the following details with regards to every transaction independent of the platform:
                  <ul className="list-disc ml-6 mt-2">
                    <li>Name of the Customer</li>
                    <li>Date of Installation</li>
                    <li>Description of the product</li>
                    <li>Number of Units</li>
                    <li>Serial Number of the Products</li>
                    <li>Delivery Note reference number.</li>
                  </ul>
                </li>
                <li>Notify the Bank within 24hours of receipt of order if it cannot deliver the products within the timeline as agreed with the Bank.</li>
                <li>Submit to a quality assurance (QA) in any case where the interest of the Bank and this Agreement so requires.</li>
                <li>Not lift (i.e., copy and paste) images of products to be displayed on the Platform from other websites, images to be used must be original images and not contents that are subject of copyright infringement, whether actual or otherwise. The Vendor hereby indemnifies the bank against any third-party claim of infraction in this regard.</li>
                <li>Not advertise or solicit users of the Platform to buy or sell products or services not listed on the Platform or related to the Platform and will contact the customer/users no more than is required for providing the services referred by the Bank.</li>
                <li>Input Standard Organization of Nigeria (SON) number (where applicable) and batch number for product listed on the platform.</li>
                <li>Ensure Tax compliance according to Federal Tax laws governing businesses and companies in Nigeria.</li>
                <li>Ensure compliance with all regulatory authorities governing purchase and sales of the products and its distribution in Nigeria.</li>
                <li>Not upload items patently offensive to the online community, such as sexually explicit content, or content that promotes obscenity, paedophilia, racism, bigotry, hatred, or physical harm of any kind against any group or individual.</li>
                <li>Not solicit for personal information from any individual unless as will be required for order placement on the platform and delivery purposes.</li>
                <li>xxiii. Not sell old or refurbished items on the platform except as shall be agreed with the Bank and such an item must be labelled appropriately.</li>
                <li>Not falsify headers or otherwise manipulate identifiers to disguise the origin of any message or transmission forwarded to the platform or the Bank on or through the Website or any service offered on or through the Website.</li>
                <li>Provide reasonable assistance to Sterling Bank with management of the relationship with each Customer and in the event of payment default by a customer under the terms of the Loan Document(s), aid with recovery.</li>
                <li>Replace/repurchase the entire product or parts of the component(s) that is/are in default or indicating signs of default on the request of the Bank for power as a service transaction at full replacement cost.</li>
                <li>Promptly respond within one (4) hour to emails and phone calls and 48 hours for visits to distress calls made by the customer or the bank in the event of emergency maintenance checks.</li>
                <li>Restore operational status of the product/system or at least to provide temporary workable intervention within 48 hours upon receipt of the notice to repair. In the event of the Vendor not been able to fix the system within 48 hours, a stop gap system should be provided to enable the customer to continue to enjoy service while the faulty component is undergoing repairs.</li>
                <li>Ensure that all its personnel, sub-contractors and/or agents who are required to demonstrate specific skills or qualifications possess such skills and execute their activities in line with prescribed marketing regulations set out by the Bank.</li>
                <li>Notwithstanding any other provision of this Agreement, the vendor shall comply with the law and all relevant regulatory requirements and directives. If any of its obligations under this Agreement are affected by an overriding government or regulatory action, the vendor shall perform its obligations in such a manner as to comply with the relevant law or regulatory requirement as far as possible and will not thereby be liable for non-compliance with this Agreement.</li>
                <li>Vendor/Partners are under obligation to promote the brand of the Bank “Altpower” for product visibility.</li>
                <li>The vendor shall route all communication with the customer on sales, referrals, faults etc. through Altpower or other channels prescribed by Altpower. The vendor shall not carry on any business directly with the customer without the due written consent of Altpower.</li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">SECTION B: REQUESTS FOR QUOTATIONS, ENERGY AUDITS, AWARD OF CONTRACTS AND INSTALLATION</h4>
              <p className="mb-4">Under this category, customers may approach Sterling for a quotation to determine the quantity of renewable energy product they may require for their premises. The Bank has agreed to consider the services of the Vendor with respect to conducting an energy audit, providing quotations, and supplying/ installing the systems, subject to the terms and conditions contained herein.</p>

              <h3 className="section-heading text-xl font-semibold">PARTIES’ OBLIGATIONS</h3>

              <h4 className="sub-section-heading text-lg font-semibold">BANK’S OBLIGATIONS</h4>
              <p className="font-semibold mb-2">The Bank shall:</p>
              <ul className="list-decimal ml-6 mb-4">
                <li>Upon receipt of the customer’s application on the platform, request for an energy audit report and quotations from the Vendor.</li>
                <li>provide contact details of the customer to enable the Vendor access to the customer’s location.</li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">VENDOR’S OBLIGATIONS</h4>
              <ul className="list-decimal ml-6 mb-4">
                <li>Vendor shall visit customer location within 1-3 working days after receiving a request from Altpower for an energy audit for audits within Lagos and 4-7working days after receiving a request for audits outside Lagos a request from Altpower for an energy audit for audits within Lagos.</li>
                <li>Vendor shall reach out to the contact person a day before visitation. Where the contact person is unreachable, vendor shall inform Altpower immediately.</li>
                <li>Vendor shall visit the customer location on the actual audit execution date communicated to the Vendor to perform the audit.</li>
                <li>Vendor shall conduct energy audit of all appliances/equipment to be powered, advise on energy saving measures and perform other activities necessary before the installation of the solar system.</li>
                <li>The Vendor shall send its energy audit report together with their proposal/quotation, electronically to The Alternative Bank/Altpower via service@altpower.ng or to the email address used by AltBank/Altpower to request for the audit.</li>
                <li>The Vendor shall send energy audit within 72hours from the time of request. AltBank shall not be obliged to send reminders, if the Vendor fails to send the required report within the agreed timeline.</li>
                <li>The Vendor’s quotation and energy audit report shall include but not limited to the following deliverables:
                  <ul className="list-disc ml-6 mt-2">
                    <li>Basic installation sequence with timelines.</li>
                    <li>The design, equipment list, quantity, and cost</li>
                    <li>Estimated annual energy production in kWh.</li>
                    <li>Battery backup time in hours</li>
                    <li>Equipment warranties.</li>
                    <li>Data sheet of PV Modules, Inverters, Batteries and Charge Controller must be submitted.</li>
                  </ul>
                </li>
                <li>The Vendor shall ensure that its quotations on its invoice shall remain fixed for a period of 4weeks starting from the date when the customer accepts the invoice.</li>
                <li>The Vendor shall promptly inform the Bank in writing if the customer requests additional systems or services that increase the cost on the agreed invoice. The Bank shall not be responsible for paying any sum not initially approved by it.</li>
              </ul>

              <h3 className="section-heading text-xl font-semibold">INSTALLATION TIMETABLE</h3>
              <p className="mb-4">For complete solar and inverter solution systems, the Vendor shall supply, mobilize, and commence installation of the solution within 1-3 days for Lagos and 1-5 days for states outside Lagos from date of receipt of an award letter from AltBank. Where Vendor could not meet time-line due to weather conditions or unavailability of customer or for other reasons beyond the control of Vendor, the Vendor shall be allowed up to 14 days to complete the instalment of the solar system. Where Customer is still not available after 14 days, the Vendor shall be entitled to reimbursement from the customer for the cost of logistics and re-mobilization which customer shall pay to Altpower and Altpower shall credit the vendor accordingly.</p>
              <p className="mb-6">If Vendor fails to deliver due to stock out or other reasons within the control of the Vendor, the award shall be withdrawn from the Vendor. Additionally, the Vendor shall receive a strike notice and a reduction in their rating. If the Vendor obtains a 2nd strike due to its failure to perform its services in accordance with the agreed timeline, the Vendor will be delisted.</p>
              <p className="mb-6">Delisting of the Vendor shall be through an email to their email address provided on the Altpower website.</p>

              <h3 className="section-heading text-xl font-semibold">PROTECTION OF THE SYSTEM</h3>
              <p className="mb-2">The following protective requirements must be put in place by the Vendor upon installation of any System:</p>
              <ul className="list-decimal ml-6 mb-4">
                <li><strong>Photovoltaic (PV) Protection:</strong> The system must be equipped with adequate rated breakers or fuses for protection. There must be Direct Current (DC) breakers for the PV Input and PV Output.</li>
                <li><strong>Alternating Current (AC) Protection:</strong> The system must be equipped with an effective and efficiently performing AC breakers or fuses for the AC Input and AC Output.</li>
                <li><strong>Grounding and Earthing:</strong> Proper grounding and earthing are essential for the protection of solar equipment. The array structure of the PV modules shall be grounded properly using adequate numbers of earthing rod where the building earthing is poor or not available.</li>
              </ul>

              <h3 className="section-heading text-xl font-semibold">OTHER RIGHTS AND OBLIGATIONS OF THE PARTIES WITH RESPECT TO THE SOLAR SYSTEMS</h3>

              <h4 className="sub-section-heading text-lg font-semibold">ONLINE SYSTEM MONITORING:</h4>
              <p className="mb-4">Every solar or inverter installation must be enabled for remote monitoring. Vendor agrees to work with our third-party telematics provider to ensure effective remote monitoring. Vendor shall install the System and ensure it is connected to a remote monitoring application and provide the monitoring application log-in details to enable the Bank and the customer to monitor the usage and activity of the Online System Monitoring and collect performance data of the system.</p>

              <h4 className="sub-section-heading text-lg font-semibold">DAMAGES TO CUSTOMER’S PROPERTY DURING INSTALLATIONS:</h4>
              <p className="mb-4">The Vendor agrees to take every reasonable precaution during the installation of the System at the Property. Altpower will not be liable for any damage to customer’s property. The Vendor shall bear liability for any damage to customer’s property during installation of the System caused by any negligent act or omission of the Vendor.</p>

              <h4 className="sub-section-heading text-lg font-semibold">SUB-CONTRACTING:</h4>
              <ul className="list-decimal ml-6 mb-4">
                <li>The Vendor shall not, without the prior consent in writing of the Bank, assign or sublet or transfer its Contract in whole or in part, its obligations to perform under this Agreement or a substantial part thereof, other than the supply of equipment, provided that any such consent shall not relieve the Vendor from any obligation, duty, or responsibility under the Contract.</li>
                <li>The Vendor shall notify the Bank in writing or via email of all sub-contracts awarded under this Agreement.</li>
                <li>In case the Vendor engages any Sub-Contractor to carry out a part of the work, the Sub-Contractor must have the requisite expertise and qualification for carrying out such part of the work.</li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">QUALITY OF EQUIPMENT, MATERIALS AND WORKMANSHIP:</h4>
              <p className="mb-4">All materials and equipment shall be of the best quality and workmanship capable of satisfactory operation. Unless otherwise specified, they shall conform in all respect to the minimum specification specified in the Annexure A of this Agreement. The Vendor shall provide the list of brands of equipment that it works with, and the equipment factsheet/datasheet. The Vendor shall not use any equipment outside the list provided to the Bank. Where the Vendor intends to add more brands of equipment to the list, they must obtain the approval of the Bank before doing so. The Vendor equipment must meet technical standard of Altpower as specified in Annexure A</p>

              <h4 className="sub-section-heading text-lg font-semibold">SAFETY OF PROJECT SITE:</h4>
              <p className="mb-4">The Vendor shall provide necessary and adequate safety measures including personal protective equipment and precautions to avoid any accident, which may cause damage to any equipment or injury to workmen. Altpower shall not be responsible for any such accidents. Also, Vendor shall take every measure to protect equipment and materials from any theft and unauthorized access. The Vendor shall keep the Site reasonably free from all unnecessary obstruction, store or remove any surplus materials, clear away any wreckage, rubbish, or temporary works from the Site, and remove any equipment no longer required at the completion of installation. After completion of installation, the Vendor shall clear away and remove all wreckage, rubbish, and debris of any kind from the Site, and shall leave the Site and Facilities clean and safe.</p>

              <h4 className="sub-section-heading text-lg font-semibold">INSPECTION & TESTING:</h4>
              <p className="mb-4">The Bank or any of its authorized representatives shall always have, access to the Project Site premises and also shall have the power at all times, to inspect and examine the materials and workmanship of project work during its installation.</p>

              <h4 className="sub-section-heading text-lg font-semibold">NEGLIGENCE:</h4>
              <p className="mb-4">If the Vendor neglects to deliver or supply or install the solar system with due diligence or refuses or neglects to comply with any reasonable order given to it in writing by the Bank or contravenes any provisions of this Agreement, the Bank may give (7) seven days’ notice in writing to the Vendor, to make good the failure, neglect or contravention complained of. If the Vendor fails to comply with the notice within 7days or reasonable time depending on the nature of affected work, in the event of failure, neglect or contravention capable of being remedied within that time, then in such case, if Sterling thinks fit, it shall be lawful for it to take the Project, or Equipment wholly or in part, out of the Vendors hand and give it to another Vendor.</p>

              <h4 className="sub-section-heading text-lg font-semibold">QUALITY OF EQUIPMENT AND GUARANTEES:</h4>
              <p className="mb-2">All brands of Vendors equipment must be registered in the Bank’s platform. Vendor shall not use other brands during installation outside the ones registered with the Bank.</p>
              <p className="mb-2">Any Work, or component thereof or equipment, that does not conform with any warranty is defective and contains a defect.</p>
              <p className="mb-2">Vendor hereby warrants that the Installation/Work, including the Equipment and each component thereof, shall be:</p>
              <ul className="list-disc ml-6 mb-4">
                <li>of the kind and quality required in accordance with this Agreement.</li>
                <li>free from Defects, including deficiencies in design, engineering, materials, and workmanship.</li>
                <li>installed and tested, in accordance with Vendors obligations under this Agreement and in accordance with the applicable Equipment specifications, including all Manufacturer’s Warranties.</li>
                <li>new, complete, and in accordance with this Agreement.</li>
              </ul>
              <p className="mb-4">Vendor shall provide the Bank with physical copies of the manufacturer's warranties and send scanned copies of the warranties to the Bank Altpower email at altpowerbiz@altpower.ng The manufacturer’s warranties shall include but not limited to the inverters, photovoltaic panels, batteries, Charge Controllers, racking systems, Cables, Electronics devices, Converters, Combiners, energy meters etc. Vendor shall NOT proceed with installation until they have sent the digital copies of the warranties to Altpower. Altpower shall issue a Notice to Proceed after receiving the digital copies of the warranties from the Vendor.</p>
              <p className="mb-4">Vendor shall review all Manufacturer’s Warranties and shall perform its responsibilities (including the performance of the Work) so that such Manufacturers’ Warranties remain in full force and effect and are enforceable, in accordance with their respective terms. The Vendor shall ensure that a Manufacturer’s Warranties run to the benefit of Altpower. All manufacturer’s Warranties shall be in such form as to permit direct enforcement by AltBank or the customer.</p>
              <p className="mb-2">Vendor agrees that:</p>
              <ul className="list-disc ml-6 mb-4">
                <li>Vendors Warranty shall apply to all Installations regardless of the provisions of any Manufacturer’s Warranties,</li>
                <li>Service of notice on Vendor that there has been a breach of a Manufacturer’s Warranties or any other warranties from Subcontractor sufficient to invoke the terms of the instrument.</li>
                <li>Vendors shall be liable jointly and severally liable to enforce warranty for sub-contractor warranties.</li>
              </ul>
              <p className="mb-2">Minimum acceptable warranties are as follows:</p>
              <ul className="list-disc ml-6 mb-4">
                <li>Solar Panel shall be warranted for peak output wattage, which should not perform at rated capacity of less than 90% for at least 10years.</li>
                <li>Inverters and charge controllers shall be warranted for at least 2years.</li>
                <li>Dry Lead Acid shall be warranted for at least 3 years while Wet Lead Acid Batteries shall be warranted for at least 2years and above.</li>
                <li>Batteries: Lithium-ion batteries shall be warranted for at least 5 years.</li>
                <li>The overall workmanship shall be warranted for a minimum of 3 years.</li>
                <li>Junction Box/ Combiner Box shall be warranted for at least 10 years.</li>
                <li>Cable and Wires shall be warranted for at least 10 years.</li>
                <li>Module Mounting Structure shall be warranted for at least 10 years.</li>
                <li>Wi-Fi/IoT shall be warranted for at least 2 years.</li>
              </ul>
              <p className="mb-4">The Vendor must ensure that the components supplied or used during installation are new, unused and of the most recent or current models and incorporate all recent improvements in design and materials unless provided otherwise in the Contract.</p>
              <p className="mb-4">During the period of the Warranty the Vendor shall remain liable to replace any equipment that becomes defective arising solely from faulty materials or workmanship. After replacement, the defective parts shall be returned to the Vendor at the expense of the Vendor.</p>
              <p className="mb-6">Any defect in the work during the Warranty period shall, therefore, be rectified by the Vendor without any extra cost to the customer within 7days from the date of receipt of such intimation from Altpower failing which Altpower shall take up rectification work at the risk and cost of the Vendor. The Vendor accepts that Altpower can debit their accounts or call-in guarantee where guarantees are provided.</p>
              <p className="mb-6">At the end of the Warranty period, the Vendor’s liability shall cease.</p>

              <h4 className="sub-section-heading text-lg font-semibold">4.9. WARRANTY EXCLUSIONS</h4>
              <p className="mb-2">The warranty shall not apply to fuses, cables, breakers or any product or parts which have been subject to misuse, neglect, accident, power fluctuations, high voltage or abnormal conditions of operation by the Customer.</p>
              <ul className="list-disc ml-6 mb-4">
                <li>Damage resulting from improper maintenance, abnormal conditions of operation or unauthorized repairs or modifications performed by anyone other than the Vendor.</li>
                <li>Any issues arising from changes made to the solar installation or its components by parties other than the Vendor.</li>
                <li>Damage or defects caused by natural disasters, acts of God, fire, flood, lightning, power surge or other similar events beyond the control of the Vendor.</li>
                <li>Any damage or defects caused using incompatible or unauthorized accessories, components, or software not provided or approved by the Vendor.</li>
              </ul>
              <p className="mb-4">The Vendor shall in no case be responsible for any indirect, incidental or consequential damage to the system if the client does not adhere to battery room operational instructions and care of the system.</p>
              <p className="mb-2">Covered repairs in this Agreement shall include:</p>
              <ul className="list-disc ml-6 mb-4">
                <li>Repairing or replacing solar panels, inverters, and other solar system components that are found to be defective or not performing to their specified capabilities.</li>
                <li>Rectifying any wiring or electrical issues directly related to the solar installation.</li>
                <li>Resolving any installation errors or deficiencies that may impact the performance or safety of the solar system.</li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">4.10 CANCELLATION OF INSTALLATION</h4>
              <p className="mb-4">If the Vendor fails to deliver, supply or install within the period(s) specified in this Agreement or in the Award letter or any extension thereof granted by the Bank, or if the Vendor fails to perform any other obligations(s) under this Agreement, the bank may cancel such order/contract and shall award the contract to another vendor. In the event of termination of this Agreement either in whole or in part, pursuant to above, The Bank may procure, upon such terms and in such manner as it deems appropriate, equipment similar to those not delivered by the Vendor. The Vendor shall be liable to the Bank for any excess costs not exceeding the liability stated in Clause 6.1 (iv) for such similar equipment. However, the Vendor may be allowed to continue the performance of the Contract to the extent not terminated.</p>
              <p className="mb-4">In case of termination of the award letter due to Vendor’s default, the Vendor may be removed from the Altpower platform for a period of 6 months.</p>
              <p className="mb-4">In case of non-Performance after a Vendor has received an order on the Platform or has been awarded a contract by the Bank, including supply of different products or brands other than what was ordered by the customer or use of different brands of equipment for projects other than those listed in Annexure A, the Bank shall have the power to annul, rescind, cancel or terminate the Contract or Order and upon its notifying in writing to the Vendor that it has so done. The decision of Altpower in this regard shall be final and binding.</p>
              <p className="mb-2">The following conditions shall contribute to the breach of contract:</p>
              <ul className="list-disc ml-6 mb-4">
                <li>If the Vendor fails to deliver any or all the Products/Equipment within the period(s) specified in this Agreement; or</li>
                <li>If the Vendor fails to perform any of their obligations(s) under this Agreement, and</li>
                <li>If the Vendor, in either of the above circumstances does not rectify the failure within a period of seven (7) days after receipt of the default notice from Altpower.</li>
              </ul>

              <h3 className="section-heading text-xl font-semibold">AFTER SALES SUPPORT AND CUSTOMER COMPLAINT</h3>

              <h4 className="sub-section-heading text-lg font-semibold">SYSTEM OPERATION AND MAINTENANCE (AFTER-SALES SUPPORT)</h4>
              <ul className="list-decimal ml-6 mb-4">
                <li><strong>Maintenance Manual:</strong> The Vendor shall provide manufacturer’s maintenance manuals for all system supplied or installed. Manuals shall include maintenance plans with the frequency of required services for regular maintenance. For each system, the Vendor shall provide a list of spare parts, consumables, accessories, and replaceable parts subject to wear as per manufacturer’s recommendation,</li>
                <li><strong>Preventive maintenance:</strong> Preventive maintenance shall be carried out by the Vendor at least two (2) times during the first year at no cost to Altpower or customers. The Vendor shall include activities such as cleaning and checking the health of the Solar PV system, cleaning of module surface, tightening of all electrical connections, and any other activity, wear and tear that may be required for proper functioning of the Solar PV system as a whole. Necessary maintenance activities, Preventive and Routine for Transformers and associated switch gears also shall be included.</li>
                <li><strong>Corrective maintenance:</strong> Whenever a fault has occurred, the Vendor has to attend to rectify the fault & the fault must be rectified within 48hrs time from the time of occurrence of fault, failing which the Vendor will be liable for liquidated damages of 10% the invoice value of the asset. Vendor’s account shall be debited for the liquidated damages amount.</li>
                <li><strong>Maintenance Commencement Date:</strong> The commencement date of the free maintenance period shall begin on the date the customer signs the Job completion certificate. The first-year free maintenance is mandatory for ALL vendors. Vendors shall submit a report detailing the dates they carried out the free preventive maintenance.</li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">VENDOR’S MAINTENANCE UNDERTAKINGS</h4>
              <p className="font-semibold mb-2">Vendor undertakes that it shall:</p>
              <ul className="list-decimal ml-6 mb-4">
                <li>Check the Equipment and carry out general, preventive, and remedial maintenance on the customer’s premises except where such maintenance checks involve substantial repairs as to require physical movement of the equipment to the Service Provider’s workshop provided that the Equipment or parts thereof shall not be moved from the customer’s premises without the prior written consent of the Bank.</li>
                <li>Ensure that the Equipment are kept in satisfactory and efficient operation at no extra cost to the Bank; keep in stock and supply at all times materials required for maintenance checks and spare parts / fittings for replacement as may be needed to carry out effective maintenance including workmanship at no extra cost to the Bank.</li>
                <li>Promptly respond within one (1) hour to distress calls made by the Bank in the event of emergency maintenance checks.</li>
                <li>Restore operational status of every Equipment (or at least to provide temporary workable interventions) if it appears to the Vendor upon investigation that the Equipment cannot be reasonably repaired within twenty-four (24) hours of receipt of the Bank’s notice to repair.</li>
                <li>Bear liability for any loss, harm and cost incurred by the Bank as a result of any delay beyond seventy-two (72) hours in responding to complaints on equipment malfunctions. Provided that the Vendor’s liability shall be limited to 0.5% of the contract sum.</li>
                <li>Employ competent technicians or workmen for the maintenance and repair of the equipment.</li>
                <li>Not move the equipment or any parts thereof from the customer’s premises without the prior written consent of the Bank.</li>
                <li>Provide the customer with Comprehensive Maintenance every quarter consisting of both preventive and remedial maintenance where the equipment is installed at a cost to be agreed on by both Parties and stated on the Vendor’s invoice.</li>
                <li>Replace any parts installed on the equipment that malfunctions or breaks down before the end warranty period within 24hrs of inspection and at no cost to the Bank.</li>
                <li>Ensure the delivery of the services at any time provided the request is received within business hours of working days, subject to other exigent exceptions as may occur from time to time. The Service Provider shall acknowledge receipt of all requests for services in accordance with the Third schedule to this Agreement.</li>
                <li>Provide appropriate work tools, materials and safety gadgets to its workmen, agent, and representatives for the purpose of carrying out the obligations under this Agreement.</li>
                <li>Undertake usual and comprehensive maintenance including but not limited to adjustments, general servicing, and replacement of parts on the Equipment.</li>
              </ul>
              <p className="font-semibold mb-2">Furthermore, the Service Provider undertakes that:</p>
              <ul className="list-disc ml-6 mb-4">
                <li>All parts and products supplied to the customer shall be of the best international standards, good quality and shall be fit for the purpose for which they are specifically supplied.</li>
                <li>No equipment will be accepted under this Agreement until it has been inspected and certified functional by the Service Provider’s engineers in writing.</li>
                <li><strong>Replacement of Parts:</strong> During replacement, parts installed and replaced in the equipment shall belong to the customer. Replacement parts will be provided for under the Comprehensive Maintenance Service at no extra cost to the Bank or customer if replaced within the warranty period.</li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">Performance Metrics for Operation and Maintenance</h4>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full">
                  <thead>
                    <tr>
                      <th>S/N</th>
                      <th>PERFORMANCE METRICS</th>
                      <th>DESCRIPTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Response Time</td>
                      <td>Emergency Maintenance …. Within one hour<br />Fault Calls … Within twenty-four (24) hours</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Service Quality</td>
                      <td>Timely Response and Prompt Resolution with little or no disruption in service<br />Optimum Quality of Parts used for replacements and best practices maintained in carrying out maintenance and repairs.</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Customer Satisfaction</td>
                      <td>Efficiency in carrying out duties to the Satisfaction of the Bank</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Quarterly Report</td>
                      <td>Prompt Receipt of Service Reports not later than three (3) working days after completion of work-done</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h4 className="sub-section-heading text-lg font-semibold">Penalty Clauses.</h4>
              <p className="mb-4">If the Service Provider fails to respond or carry out preventive and/or remedial maintenance in accordance with Performance Matrices detailed in the table below and the offences listed below occurs, penalties itemized in the table below shall apply. This grid is not exhaustive and may be amended by the Bank at any time, provided that, notice of such amendment is given to the Service Provider.</p>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full">
                  <thead>
                    <tr>
                      <th>S/N</th>
                      <th>OFFENCE / BREACHES</th>
                      <th>FREQUENCY</th>
                      <th>SANCTIONS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Exposed connecting equipment, cables to the</td>
                      <td>Case by case</td>
                      <td>No payments until cabling, trunking and aesthetics are certified okay by Altpower or customer</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Stains during or after repairs, installation</td>
                      <td>Case by case</td>
                      <td>Service Provider responsible for affected areas, repainting where desires, to be cleaning, Including customer</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Failure to rectify customer’s complaint within 72 hours of report</td>
                      <td>First Occurrence</td>
                      <td>Warning email is sent. Vendor rating will be reduced by one star</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Second Occurrence</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Use of inferior or substandard materials for repairs</td>
                      <td>Once caught</td>
                      <td>Service Provider to be delisted from being a partner to Altpower</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Over invoicing</td>
                      <td>Once confirmed</td>
                      <td>Service Provider to be delisted from being a partner to Altpower</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>Breach of SLA</td>
                      <td>Twice in a quarter</td>
                      <td>Service Provider to be put on probation</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Thrice in a quarter</td>
                      <td>Service Provider to be placed on a six (6) week suspension</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Over thrice in a quarter</td>
                      <td>Service Provider to be delisted from being a partner to Altpower</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Failure to replace parts under warranty within seventy-two (72) hours of notification</td>
                      <td>First Occurrence</td>
                      <td>Issuance of Letter of Displeasure to Service Provider</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Second Occurrence</td>
                      <td>Service Provider to be put on probation</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Third Occurrence</td>
                      <td>Service Provider to be delisted from being as partner to Altpower</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>Failure to carry out routine quarterly comprehensive maintenance</td>
                      <td>Once in a quarter</td>
                      <td>Issuance of Letter of Displeasure</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Twice in a quarter</td>
                      <td>Non-renewal of contract in future</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>Incompetence of workmen and technicians</td>
                      <td>Once confirmed</td>
                      <td>Service Provider to be delisted from being a partner to Altpower</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>Failure to hand over replaced parts to the Bank’s official</td>
                      <td>Once discovered</td>
                      <td>Service Provider to be delisted from being a partner to Altpower</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>Damage to property of the Customer in course of maintenance</td>
                      <td>Case by case</td>
                      <td>Service Provider to bear the full cost of repairs or purchase</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>Compromise of the Equipment in the event of an information / security incidence</td>
                      <td>Once confirmed</td>
                      <td>Service Provider to be delisted and handed over to the authorities</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h4 className="sub-section-heading text-lg font-semibold">RESOLUTION OF CUSTOMERS COMPLAINTS</h4>
              <p className="mb-2">The Vendor agreed to resolve customer’s complaint within the following timelines:</p>
              <ul className="list-disc ml-6 mb-4">
                <li>Respond to calls/email from Altpower within 1(one) hour.</li>
                <li>Offer online solution-1 hour</li>
                <li>Schedule visitation – 48 hours</li>
                <li>Fill out fault call report- 48 hours</li>
                <li>Provide stop gap equipment if damaged equipment is to be taken away for more than 2 days on the day the equipment is removed from the customer’s premises.</li>
                <li>Missed SLA will result in sanction according to the sanction grid in 5.5 above.</li>
              </ul>

              <h3 className="section-heading text-xl font-semibold">6. PAYMENTS, FEES AND SERVICE CHARGE</h3>

              <h4 className="sub-section-heading text-lg font-semibold">EQUIPMENT INSTALLATION PAYMENT TERMS</h4>
              <ul className="list-decimal ml-6 mb-4">
                <li>The amount stated on the invoice, or on the Bank’s Altpower website or on the quotation/proposal shall be fixed and shall not change after the Award of Contract to supply/install a product or after the customer has made an order</li>
                <li>The Vendor shall be deemed to have satisfied itself as to the correctness and sufficiency of the Value stated on the invoice, proposal or Altpower website, which shall cover all its obligations under the Contract.</li>
                <li>The Bank shall pay the Vendor in the following manner:
                  <ul className="list-disc ml-6 mt-2">
                    <li>Vendor shall be paid 100% of the price quoted on the invoice/platform 7 days after installation is completed subject to customer executing the Vendors job completion certificate.</li>
                    <li>where Altpower refers the customer to the Vendor or where the transaction is consummated via Altpower website, Altpower shall take a 5% service charge before paying the Vendor as stated in Section 6.1 (iii)(a).</li>
                    <li>where the customer was referred to Altpower by the Vendor, Altpower shall not take any service charge before paying the Vendor as stated in Section 6.1 (iii)(a) above,</li>
                  </ul>
                </li>
                <li>All payments shall be net of Withholding Tax (WHT) and Value Added Tax (VAT) where applicable.</li>
                <li>Where a Vendor fails to move to site within the SLA or timeline specified in the award of contract or according to the Agreed SLA, they shall pay Altpower liquidated damages for both delay and performance at 0.5% of the contract sum for every week that they failed to mobilize.</li>
                <li>Altpower shall deduct the accrued amount on liquidated damages from the balance due to the Vendor at the completion of the installation.</li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">PAYMENT TERMS AND TAXES FOR SHIPMENTS AND PRODUCTS DISPLAYED ON ALTPOWER</h4>
              <ul className="list-decimal ml-6 mb-4">
                <li>The Bank reserves the right to increase the service charge percentage and would give the vendor two (2) weeks’ prior notice of any changes in the service charge.</li>
                <li>The service charge shall be deducted by the Bank before remittance of the sale price into the vendor’s account domiciled with the Bank.</li>
                <li>In the event any order is reversed due to “Damaged product” or not in line with the specified order, Vendor agrees that Altpower shall levy the Service charge of 5%, plus a penalty which will be a percentage of the product price as may be decided between the vendor and Altpower and the said charges will be deducted from the total amount due and payable to Vendor.</li>
                <li>Altpower will debit the Service charges (up to a maximum limit of NGN10,000.00) from the Vendor in the event the product cannot be delivered by the Vendor if the product is “out of stock” and in such an event, the Vendor shall be liable to bear all the cost and claims (including cost of legal proceedings, cost of attorneys, claims, etc.) raised against Altpower.</li>
                <li>To ensure good record keeping, Vendor shall prepare a consolidated advice list of all orders delivered to Altpower, on the 30th date of every month and submit it to Altpower.</li>
              </ul>

              <h3 className="section-heading text-xl font-semibold">7.GENERAL</h3>

              <h4 className="sub-section-heading text-lg font-semibold">TERMINATION OF THIS AGREEMENT</h4>
              <ul className="list-decimal ml-6 mb-4">
                <li>Either Party reserves the right to terminate the Agreement (in whole or in part), upon a thirty (30) days’ prior notice in writing to the other Party.</li>
                <li>This Agreement may also be terminated immediately with a written notice to the other Party upon the occurrence of the following events:
                  <ul className="list-disc ml-6 mt-2">
                    <li>if by reason of any regulatory sanction, or withdrawal of any governmental authorization, approval, or license, either Party is unable to substantially fulfil its obligations herein stated.</li>
                    <li>insolvency, judicial management, winding-up, passing of a resolution for winding up, receipt of an administration order, seizing of assets in execution or any order of Court which has not been appealed or challenged 7 (seven) days after being granted,</li>
                    <li>if it discovers that the other party is involved in any activity that is likely to bring disrepute to the aggrieved party in any way.</li>
                    <li>breach of any provision of this Agreement by the other Party, provided that where the breach is capable of being remedied, due notice (written) has been given to the other Party of the alleged breach and the Party in breach has not cured the breach within timeline permitted under this Agreement.</li>
                    <li>In the case of a breach which is not capable of being remedied, the aggrieved Party shall have the right to terminate this Agreement by giving the other Party written notice of its intention to terminate the Agreement which shall take effect forthwith from the date of receipt of the notice.</li>
                    <li>in the event of a change of control in the management of a Party which in the reasonable opinion of the other Party is detrimental to the second Party’s interests.</li>
                  </ul>
                </li>
                <li>Termination of this Agreement (howsoever occasioned) shall not affect any rights, remedies, obligations, or liabilities of the Parties that have accrued up to the date of termination or provisions of this Agreement intended to survive termination.</li>
                <li>Upon termination of this Agreement, the rights/licenses granted herein shall immediately cease.</li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">FORCE MAJEURE</h4>
              <ul className="list-decimal ml-6 mb-4">
                <li>For the purposes of this Agreement, the term “Force Majeure Event” shall mean any act of war (whether war be declared or not), governmental decision, policy, act or omission (e.g. delay or failure to issue, or withdrawal, of any license, permit or authorisation), embargo, hostilities, riots, civil commotion, sabotage, emergency, strike, industrial or labour dispute, disturbance in supplies from normally reliable sources (e.g. electricity, water, fuel and the like), lockout, delay or failure from a sub- contractor or supplier due to Force Majeure as defined herein, accident, fire, earthquake, flood, storm, tempest, natural disasters, lightening, hurricanes, explosion, epidemics, quarantine restrictions, any act of God or any other cause beyond the reasonable control of the Affected Party</li>
                <li>Neither Party shall have responsibility or liability with respect to any failure or delay in the performance of any term or condition of this Agreement or any supplementary to it if such failure or delay in performance is due in whole or in part to a Force Majeure Event.</li>
                <li>This Agreement shall be suspended until the removal of such circumstances and the time for performance extended for an adequate period.</li>
                <li>If the Force Majeure Event shall exceed thirty (30) days in duration, the unaffected Party shall have the right to terminate this Agreement upon notifying the affected Party.</li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">NOTICES:</h4>
              <p className="mb-2">Notice to the parties shall be duly served if issued in writing and addressed to the parties and is delivered at the addresses stated herein</p>
              <ul className="list-disc ml-6 mb-4">
                <li>To the Bank: Head, Altpower The Alternative Bank Limited.
                  <br />234, Ikorodu,
                  <br />Lagos.
                </li>
                <li>To: The Managing Director
                  <br />{loggedInUser && loggedInUser.businessName}.
                  <br />{loggedInUser && loggedInUser.businessAddress}
                </li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">CONFIDENTIALITY</h4>
              <p className="mb-4">All information and documents (whether financial, technical, or otherwise) obtained by any Party (Receiving Party) or its employees, Vendors, consultants or agent which are not published or otherwise publicly available shall be kept confidential and not disclosed to third parties or the public except with the prior written approval of the disclosing Party (Disclosing Party) or as required by laws of the Federal Republic of Nigeria. This prohibition shall not prevent the Receiving Party, with the consent of the Disclosing Party, from issuing press releases containing non-sensitive information in relation to the progress of the Platform. This covenant shall survive the termination of this Agreement. The provision of this section shall be read and construed alongside any signed non-disclosure/non-compete Agreement between the Parties.</p>
              <p className="mb-4">The Vendor acknowledges that the relationship between the Bank and its customers is governed by the privacy policy and therefore shall not use or divulge customers’ information in any other way except as permitted in this Agreement.</p>

              <h4 className="sub-section-heading text-lg font-semibold">INDEMNITY</h4>
              <p className="mb-2">The Vendor hereby indemnifies and undertakes to hold the Bank harmless and free from any liability arising out of all claims:</p>
              <ul className="list-disc ml-6 mb-4">
                <li>for negligence, fraud, willful misconduct, damages, breach of intellectual property, arising out of the Vendor’s breach of the terms of this Agreement.</li>
                <li>arising in relation to matters outside the Bank’s control, including but not limited to the quality of goods and services provided by the Vendor.</li>
                <li>resulting from any violation of laws and regulations by the Vendor.</li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">WARRANTIES</h4>
              <ul className="list-decimal ml-6 mb-4">
                <li>Each Party warrants that it has full power, authority, and legal right to execute, deliver and perform its obligations under this Agreement.</li>
                <li>Each Party agrees that the execution, delivery, and performance of this Agreement has been authorized by all necessary action on the part of such party and does not contravene any law, regulation, rule, order, Agreement or commitment binding on such party.</li>
                <li>The Vendor further warrants that information listed on the Platform relating to its products satisfies all legal requirements and satisfies information requirements for consumer protection.</li>
                <li>The Vendor warrants that there are no ongoing criminal, bankruptcy or tax proceedings or other penalties outstanding in relation to the products it sells through the platform.</li>
              </ul>
              <p className="mb-2">The Vendor represents and warrants to the Bank that:</p>
              <ul className="list-disc ml-6 mb-4">
                <li>it has good transferable title to the products and all necessary licenses required for the sale of the product.</li>
                <li>the product will perform in conformity with specifications and documentation supplied by Vendor.</li>
                <li>unless, expressly stated on the label, the products are new and do not contain used or reconditioned parts,</li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">INTELLECTUAL PROPERTY AND LICENSING</h4>
              <ul className="list-decimal ml-6 mb-4">
                <li>The Bank shall retain all title, right, and interest to its own intellectual property and no implied license of any kind, nor rights under any patent, trademark, trade- secret, copyright or any other proprietary rights of the Bank shall be deemed to have been granted by the Bank to the Vendor under this Agreement, unless expressly stated in writing.</li>
                <li>The Bank may publish online the Vendor’s products, logos and other materials required. The Vendor grants the Bank a royalty- free, perpetual, unrestricted license to use and distribute any product provided by it, for the purpose of advertising the Platform.</li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">LIABILITY</h4>
              <ul className="list-decimal ml-6 mb-4">
                <li>Notwithstanding anything to the contrary contained in this Agreement neither Party shall be liable to the other for any indirect or consequential loss or damage, including and without limitation to loss of profit, revenue, anticipated savings, business transactions or goodwill or other contracts.</li>
                <li>The Bank shall use it best effort to ensure that its services to the vendor will be free from malfunctions and will exercise all reasonable care and skill to resolve any such case of malfunction.</li>
                <li>Notwithstanding anything to the contrary contained in this Agreement, the Vendor shall be liable to pay all taxes and rates due on the services it renders in respect of its products.</li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">SETTLEMENT OF DISPUTES</h4>
              <p className="mb-4">All disputes and disagreements that may arise from this Agreement shall be settled amicably in good faith failing which they shall be referred to and settled by Mediation. Any such dispute shall be referred for Mediation under the provisions of the Lagos Multi-Door Court House Rules in force, or any statutory modifications or re- enactment thereof for the time being in force in Nigeria. Each party shall bear their respective cost of the mediation.</p>

              <h4 className="sub-section-heading text-lg font-semibold">GOVERNING LAW</h4>
              <p className="mb-4">This Agreement shall be construed in accordance with the laws of the Federal Republic of Nigeria.</p>

              <h4 className="sub-section-heading text-lg font-semibold">ANTI-CORRUPTION</h4>
              <ul className="list-decimal ml-6 mb-4">
                <li>Each Party hereby undertakes that, at the date of this Agreement, itself, its directors, officers, employees or affiliates have not offered, promised, given, authorized, solicited or accepted any undue pecuniary or other advantage of any kind (or implied that they will or might do any such thing at any time in the future) in any way connected with this Agreement and that it has taken reasonable measures to prevent subcontractors, agents or other third parties subject to its control or determining influence, from doing so.</li>
                <li>Parties shall comply with all applicable anti-bribery and anti-corruption Laws in Nigeria.</li>
                <li>Parties shall ensure that this Clause is observed in all relationship with its customers.</li>
              </ul>

              <h4 className="sub-section-heading text-lg font-semibold">OTHER PROVISIONS</h4>
              <ul className="list-decimal ml-6 mb-4">
                <li>The Vendor hereby acknowledges that in line with regulatory standards, Imperium reserves the right to audit or nominate a reputable firm to audit the Vendor’s records, operations, processes, installations and infrastructure as may be applicable or relevant to the performance of the obligations under this Agreement. Such audit shall be carried out under terms to be decided upon by the Parties, provided that notice of such audit exercise is provided to the Vendor at least five (5) Business Days’ prior.</li>
                <li>Each party, its employees and agents, shall not be deemed to be employees, or agents of the other and shall not have the authority to bind the other. Neither party shall have any power or authority to act in the name or on behalf of the other party or incur or accept any liability or obligation binding upon the other party without the express written consent of the party to be bound.</li>
                <li>No alteration, variation or agreed cancellation of any part of this Agreement shall be of any effect, unless made in writing and signed by both Parties.</li>
                <li>This Agreement constitutes the whole Agreement between the parties with regards to the subject matter thereof and no warranties or representations of any nature whatsoever other than set out in this Agreement have been given by any of the Parties.</li>
                <li>No relaxation or indulgence which either party may show to the other Party in any way shall prejudice or be deemed to be a waiver of its rights hereunder.</li>
                <li>Every provision of this Agreement (excluding only those provisions, which are essential at law for a valid binding Agreement to be constituted) shall be deemed separate and severable from the remaining provisions of this Agreement. If any of the provisions of this Agreement (excluding only those provisions, which are essential at law for a valid and binding Agreement to be constituted) is found by any court of competent jurisdiction to be invalid and/or unenforceable then, notwithstanding such invalidity and/or unenforceability, the remaining provisions of this Agreement shall be and remain of full force and effect.</li>
                <li>Any substantive provision appearing in, or as a part of any interpretative provision of this Agreement shall have effect in accordance with its tenor, notwithstanding the context in which it appears.</li>
                <li>This Agreement may be executed in any number of counterparts, each of which so executed shall be deemed to be an original, and such counterparts shall together constitute but one and the same Agreement.</li>
                <li>The parties may sign and transmit to one another an electronic signature of this Agreement as a PDF document via email transmission, which signature shall be binding on the party whose name is contained therein. Any party providing an electronic signature agrees to promptly execute and deliver to the other parties an original signed Agreement upon request. Failure to deliver an original shall not affect the validity, enforceability, of binding effect of this Agreement.</li>
              </ul>

              <h3 className="section-heading text-xl font-semibold">ANNEXURES</h3>

              <h4 className="sub-section-heading text-lg font-semibold">Annexure A– Technical Requirements and Standard for Equipment</h4>

              <h5 className="text-lg font-semibold mb-2">Technical Standards for PV Modules</h5>
              <ul className="list-disc ml-6 mb-4">
                <li>The PV modules and Solar Cell must be certified for use by IMPERIUM technical team before deployment.</li>
                <li>The rated power of solar PV module shall have maximum tolerance up to +3%.</li>
                <li>The peak-power point current of any supplied module string (series connected modules) shall not vary by +1% from the respective arithmetic means for all modules and/or for all module strings (connected to the same MPPT), as the case may be.</li>
                <li>The peak-power point voltage of any supplied module string (series connected modules) shall not vary by + 2% from the respective arithmetic means for all modules and/or for all module strings (connected to the same MPPT), as the case may be.</li>
                <li>The temperature co-efficient power of the PV module shall be equal to or better than -0.45%/°C.</li>
                <li>Solar PV modules of minimum capacity 400Wp to be used.</li>
                <li>The PV Module efficiency should be minimum 16%.</li>
                <li>Solar PV modules of minimum fill factor 75%, to be used.</li>
                <li>The PV modules shall be equipped with IP 65 or better protection level junction box with required numbers of bypass diodes of appropriate rating and appropriately sized output power cable of symmetric length with MC4 or equivalent solar connectors.</li>
                <li>All PV modules should carry a performance warranty of &gt;90% during the first 5 years, and &gt;80% during the next 10 years. Further, module shall have performance warranty of &gt;97% during the first year of installation—degradation of the module below 1 % per annum.</li>
                <li>The manufacturer should warrant the Solar Module(s) to be free from the defects and/or failures specified below for a period not less than five (05) years from the date of commissioning:
                  <ul className="list-circle ml-6 mt-2">
                    <li>Defects and/or failures due to manufacturing</li>
                    <li>Defects and/or failures due to quality of materials.</li>
                    <li>Nonconformity to specifications due to faulty manufacturing and/or inspection processes. If the solar Module(s) fails to conform to this warranty, the manufacturer will repair or replace the solar module(s), at the Owners sole option.</li>
                  </ul>
                </li>
                <li>PV modules must be tested and approved by accredited and approved test centers with documentation to the effect.</li>
                <li>The following minimum information must be included in the manufacturers label of the Inverters:
                  <ul className="list-circle ml-6 mt-2">
                    <li>Brand</li>
                    <li>Model</li>
                    <li>Serial Number</li>
                    <li>Nominal power in Watt</li>
                    <li>Nominal voltage</li>
                  </ul>
                </li>
                <li>Applicable Standards shall be IEC 61215; IS 14286; IEC 61730 Part 1 and 2; IEC 61701</li>
              </ul>

              <h5 className="text-lg font-semibold mb-2">Technical Standards for Batteries</h5>
              <ul className="list-disc ml-6 mb-4">
                <li>All batteries must be certified for use by IMPERIUM technical team before deployment:</li>
                <li>The battery storage shall be designed and constructed in a manner to minimize DC-DC and DC-AC conversion losses.</li>
                <li>Battery installation shall conform to the manufacturer’s published data sheet(s) and installation manuals.</li>
                <li>Batteries should be stored in a cool, well-ventilated area away from ignition sources. Where batteries are arranged in two or more tiers, adequate circulation of air must be ensured.</li>
                <li>Battery string configuration and charging/discharging requirements must be compatible with the proposed inverter.</li>
                <li>Battery should be store in such a way as to prevent spill of electrolyte or acid. They should be fixed to prevent any movement.</li>
                <li>All conductors for the battery storage system, both DC and AC, shall be copper.</li>
                <li>Conductors shall be appropriately sized to minimize voltage drop to &lt;2% for the voltage and current of the expected load. Connectors shall be mechanically crimped and soldered to provide a low resistance connection, reducing the heat build-up at the connecting junction.</li>
                <li>Battery inverters shall be commercial grade, bi-directional, pure sine wave, grid forming/grid interactive inverters for islanded applications, and specifically designed for battery storage installations.</li>
                <li>Preference shall be given to inverters which require minimum levels of annual maintenance.</li>
                <li>Inverter voltage, current, and frequency capability are to be selected in accordance with the battery technology and chemistry, and conditions local to the installation site.</li>
                <li>All batteries shall be of the same brand and model, with the same capacity and voltage.</li>
                <li>If batteries are installed in an enclosure or building, Vendor shall ensure that there is lighting sufficient to provide maintenance personnel levels of light necessary to perform routine maintenance tasks.</li>
                <li>Racks and trays shall be designed and constructed in such a way as to allow for easy removal and replacement of individual battery modules.</li>
                <li>The minimum battery warranty shall be a minimum of 3 years for Lead-Acid batteries; 2 years for Tubular batteries, and 5 years for lithium-ion batteries.</li>
                <li>The expected lifetime for the batteries shall be a minimum of 5 years for Lead-Acid batteries; 5 years for Tubular batteries, and 10 years for lithium-ion batteries.</li>
                <li>Battery should be stored in such a way as to prevent spill of electrolyte or acid. They should be fixed to prevent any movement.</li>
                <li>The battery must be able to withstand temperatures from -10° C to + 50° C.</li>
                <li>The maximum permissible self-discharge rate is 5 percent of rated capacity per month at 25 C.</li>
                <li>Cycle life of lithium-ion batteries must be greater than 6,000 when discharged down to depth of discharge (DOD) of 80% percent discharge rate, while cycle life of other battery types must be greater than 1500 at depth of discharge (DOD) of 50% percent discharge rate.</li>
                <li>20) Applicable Standards: IEC 62133, IEC 61960, IEC 60896 - 21/22; ЕN 50272 - 2; IEC 61427 – 1/2; IEC 61056 - 1; IEEE 1184; IEEE 1187; IEEE 1188. All batteries shall conform to minimum of UL1741, IEC62109, EN61000, or IEEE 2030.5 standards. IEC 62109-1, IEC 62109-2, IEC 60068-2 (1, 2, 14, 30), IS/IEC 61683</li>
                <li>The following minimum information must be included in the manufacturers label of the Inverters:
                  <ul className="list-circle ml-6 mt-2">
                    <li>Brand</li>
                    <li>Model</li>
                    <li>Serial Number</li>
                    <li>Nominal power in Watt</li>
                    <li>Nominal voltage</li>
                  </ul>
                </li>
              </ul>

              <h5 className="text-lg font-semibold mb-2">Technical Standards for Inverter</h5>
              <ul className="list-disc ml-6 mb-4">
                <li>Inverters should comply with applicable equivalent BIS standard for efficiency measurements and environmental tests as per standard codes.</li>
                <li>For Hybrid Inverters, Maximum Power Point Tracker (MPPT) shall be integrated in the inverter to maximize energy drawn from the array. All inverters shall be compliant for electromagnetic compatibility, harmonics, Surge, etc.</li>
                <li>Inverters MUST have remote monitoring capability or/and capability to integrate to IoT telematics.</li>
                <li>The Inverter shall have overloading capacity of minimum 10%.</li>
                <li>Ambient temperature considered: -20°C to 60°C</li>
                <li>Humidity: 95 % Non-condensing</li>
                <li>Protection of Enclosure: IP-54 (Minimum) for indoor and IP-65(Minimum) for outdoor.</li>
                <li>No-load losses: Less than 1% of rated power</li>
                <li>Inverter efficiency (Min.): &gt;93% (In case of 10 kW or above with in-built galvanic isolation) &gt;97% (In case of 10 kW or above without inbuilt galvanic isolation)</li>
                <li>Inverter efficiency (minimum): &gt; 90% (In case of less than 10 kW)</li>
                <li>Total Hamonic Distortion (THD): &lt; 3%</li>
                <li>Power Factor (PF): &lt; 0.8 (lag or lead)</li>
                <li>Should not inject DC power more than 0.5% of full rated output at the interconnection point.</li>
                <li>The output power factor of inverter should be suitable for all voltage ranges or sink of reactive power,</li>
                <li>inverter should have internal protection arrangement against any sustain fault in feeder line and against lightning on feeder.</li>
                <li>Inverter shall be capable of complete automatic operation including wake-up synchronization & shutdown.</li>
                <li>Fuses should clearly be labelled to show the fuse current rating and voltage rating for fuses that may be changed at the installed site.</li>
                <li>Inverter voltage, current, and frequency capability are to be selected in accordance with the battery technology and chemistry, and conditions local to the installation site.</li>
                <li>Battery inverters shall be commercial grade, bi-directional, pure sine wave, grid forming/grid interactive inverters for islanded applications, and specifically designed for battery storage installations.</li>
                <li>Inverters shall be capable of providing reactive (VAR) power when necessary.</li>
                <li>Inverters shall have a minimum 5-year manufacturer’s warranty covering defects and workmanship.</li>
                <li>Real-time system data shall be provided, accessible through both the remote and local Human Machine Interface (HMI).</li>
                <li>The following minimum information must be included in the manufacturers label of the Inverters:
                  <ul className="list-circle ml-6 mt-2">
                    <li>Brand</li>
                    <li>Model</li>
                    <li>Serial Number</li>
                    <li>Nominal power in Watt</li>
                    <li>Nominal voltage</li>
                  </ul>
                </li>
                <li>23) Applicable standards: IEC 62109-1, IEC 62109-2, IEC 60068-2 (1, 2, 14, 30), IS/IEC 61683</li>
                <li>Inverters shall consist of associated control, protection and data logging devices and remote monitoring hardware and compatible with software used for IOT/Wi-Fi integration.</li>
                <li>The minimum European efficiency of the inverter shall be 98% load as per IEC 61683 standard for measuring efficiency.</li>
                <li>Where Hybrids Inverters are used, Maximum power point tracker (MPPT) shall be the acceptable integration to the power conditioner unit to maximize energy drawn from the Solar PV array. The MPPT should be microprocessor based to minimize power losses. The MPPT unit shall confirm to IEC 62093</li>
                <li>Leakage Faults: The INVERTER shall have the required protection arrangements against grounding leakage faults.</li>
                <li>Over Voltage & Current: In addition, over voltage protection shall be provided between positive and negative conductor and earth ground such as Surge Protection Devices (SPD).</li>
                <li>Inverter shall have provision for adjusting DC input current and should trip against sustainable fault downstream and shall not start till the fault is rectified.</li>
                <li>Inverters must have LCD display to monitor, but not limited to, the following: DC power input, DC input voltage, DC Current, AC power output, AC voltage, Display of sine wave with distortion, if any. On no account should vendor use inverters without LCD display.</li>
                <li>Inverter must provide protection against:
                  <ul className="list-circle ml-6 mt-2">
                    <li>Over current</li>
                    <li>Sync loss</li>
                    <li>Over temperature</li>
                    <li>DC bus over voltage</li>
                    <li>Cooling Fan failure</li>
                    <li>Short circuit</li>
                    <li>Lightning</li>
                    <li>Earth fault</li>
                    <li>Surge voltage induced at output due to external source.</li>
                    <li>Power regulation in the event of thermal overloading</li>
                    <li>Set point pre-selection for VAR control.</li>
                    <li>Bus communication via -interface for integration</li>
                    <li>Remote control via telephone modem or mini web server</li>
                    <li>Integrated protection in the DC and three phase system</li>
                    <li>Insulation monitoring of the PV array with sequential fault location</li>
                  </ul>
                </li>
                <li>Applicable Standards
                  <ul className="list-circle ml-6 mt-2">
                    <li>Efficiency measurement: IEC 61683</li>
                    <li>Environmental Testing: IEC 60068-2 or IEC 62093</li>
                    <li>EMC, harmonics, etc.: IEC 61000 series, 6-2, 6-4 and other relevant Standards.</li>
                    <li>Electrical safety: IEC 62109 (1&2), EN 50178 or equivalent</li>
                    <li>Protection against islanding of grid: IEEE1547/ UL1741/ IEC 62116 or equivalent</li>
                  </ul>
                </li>
              </ul>

              <h5 className="text-lg font-semibold mb-2">Technical Standards for Mounting Structure</h5>
              <ul className="list-disc ml-6 mb-4">
                <li>The structure design shall be appropriate and innovative. It must follow the existing profile of the roof or any other place where the PV is to be mounted.</li>
                <li>The structure shall be designed to allow easy replacement of any module and shall be in line with the site requirements.</li>
                <li>For multiple module mounting structures located in a single row, the alignment of all modules shall be within an error limit of maximum 10mm.</li>
                <li>The mounting structure shall be warranted for 15 years.</li>
              </ul>

              <h5 className="text-lg font-semibold mb-2">Technical Standards for Junction Box/ Combiner Box</h5>
              <ul className="list-disc ml-6 mb-4">
                <li>All junction/ combiner boxes including the string junction box, array junction box and main junction box/ combiner box should be equipped with appropriate functionality, safety (including fuses, grounding, contacts etc.) and protection.</li>
                <li>The rating of all components of JB’s shall be suitable with adequate factor of safety to interconnect the Solar PV array.</li>
                <li>The junction boxes shall be dust, vermin, waterproof and shall comply with IEC 62208, which should be sunlight/ UV resistant as well as fire retardant & must have maximum protection.</li>
                <li>The Array Junction Box will also have suitable surge protection. In addition, over voltage protection shall be provided between positive and negative conductor and earth ground such as Surge Protection Device (SPD). The maintenance free earthing shall be done as per the relevant standards.</li>
                <li>Adequate capacity solar DC fuses & isolating miniature circuit breakers should be provided if required.</li>
                <li>The Junction Box/Combiner Box shall be warranted for a minimum of 15 years.</li>
              </ul>

              <h5 className="text-lg font-semibold mb-2">Technical Standards for Cable and Wires</h5>
              <ul className="list-disc ml-6 mb-4">
                <li>All cables and connectors for use for installation must be of solar grade which can withstand harsh environmental conditions including high temperatures, UV radiation, rain, humidity, dirt, burial and attack by moss and microbes for a minimum of 10years.</li>
                <li>Wires with sufficient ampere capacity and parameters shall be used so that maximum voltage-drop at full power from the PV modules to inverter should be less than 1.5%.</li>
                <li>Cable terminations shall be made with suitable cable lugs & sockets. All cables must be neatly trunked with no exposure.</li>
              </ul>

              <h5 className="text-lg font-semibold mb-2">Technical Standards for the Solar/Inverter System</h5>
              <ul className="list-disc ml-6 mb-4">
                <li>All quotations for systems size from 10KW and above must come with provision for lightning and thunder arrestors where the facility does not have a lightning and thunder arrestor in place.</li>
                <li>Necessary foundation / anchoring for holding the lightning conductor in position to be made after giving due consideration to shadow on PV array, maximum wind speed and maintenance requirement at site in future.</li>
              </ul>

              <h3 className="section-heading text-xl font-semibold">VENDOR REQUIREMENTS:</h3>
              <p className="mb-4">For each questions, kindly choose points between 1-5 and provide responses:</p>

              <h5 className="text-lg font-semibold mb-2">General Information</h5>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Criteria</th>
                      <th>Range</th>
                      <th>Points</th>
                      <th>Responses</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Years Established</td>
                      <td>&gt;5</td>
                      <td>5</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>2-5</td>
                      <td>3</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>&lt;2</td>
                      <td>1</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Size of Firm (No of people)</td>
                      <td>2-5</td>
                      <td>3</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>&lt;2</td>
                      <td>1</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>&lt;10</td>
                      <td>1</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Annual Turnover</td>
                      <td>&gt;N500M</td>
                      <td>5</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>N101 - N500M</td>
                      <td>3</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>&lt;N100M</td>
                      <td>1</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Turnover of Solar Home Systems as a percentage of total annual turnover</td>
                      <td>&gt;80%</td>
                      <td>5</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>40 - 80%</td>
                      <td>3</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>&lt;40%</td>
                      <td>1</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h5 className="text-lg font-semibold mb-2">Structure & Experience</h5>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Criteria</th>
                      <th>Range</th>
                      <th>Points</th>
                      <th>Responses</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>5</td>
                      <td>Business Structure e.g., Joint Venture, partnership, Plc, Ltd, Proprietorship etc.</td>
                      <td>Excellent</td>
                      <td>5</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Average</td>
                      <td>3</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Poor</td>
                      <td>1</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>Relevance of CVs of Key Engineers, experts, technicians in RE (i.e. local or international qualifications obtained</td>
                      <td>Excellent</td>
                      <td>5</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Average</td>
                      <td>3</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Poor</td>
                      <td>1</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Local presences or ability to quickly mobilize locally in niche market</td>
                      <td>High</td>
                      <td>5</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Average</td>
                      <td>3</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Poor</td>
                      <td>1</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>No of Installations done</td>
                      <td>&gt;500</td>
                      <td>5</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>100 - 499</td>
                      <td>3</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>&lt;100</td>
                      <td>1</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>Experience in Nigerian Market (No of Projects, &gt; 10kw)</td>
                      <td>&gt;6</td>
                      <td>5</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>3 - 5</td>
                      <td>3</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>&lt;2</td>
                      <td>1</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>Experience with Solar Systems (No. of projects, size and complexity)</td>
                      <td>&gt;5</td>
                      <td>5</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>3 - 5</td>
                      <td>3</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>&lt;2</td>
                      <td>1</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h5 className="text-lg font-semibold mb-2">Equipment & Certifications</h5>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Criteria</th>
                      <th>Range</th>
                      <th>Points</th>
                      <th>Responses</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>11</td>
                      <td>Renewable Energy equipment design and performance in accordance to International Standards (IEC, DE, ISO or relevant) RE Companies which will be qualified by this EOI must ensure that their future designs submitted for this project adhere to the standards listed here. Deviating from these standards will cause disqualification</td>
                      <td>PV Panels: At least IEC 61215, Edition and IEC 61739</td>
                      <td>10</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Inverters: At least Harmonic Current (IEC, 6100-3-2, and/or IEC 61000-3-4), IEC 62109-1/2</td>
                      <td>10</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>Batteries: At least IEC 62133, IEC 61960</td>
                      <td>10</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>Level of Warranty of Solar Solution (in years)</td>
                      <td>&gt;5</td>
                      <td>20</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>3 - 5</td>
                      <td>10</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>1 - 2</td>
                      <td>5</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colSpan={2}>Total Score</td>
                      <td></td>
                      <td>100</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colSpan={2}>Pass Score</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 className="section-heading text-xl font-semibold">IN WITNESS, OF WHICH the parties have executed this agreement, in the manner below, the day and year first above written.</h3>

              <p className="mb-4">Signed by the duly authorized representatives of THE ALTERNTIVE BANK LIMITED (Trading under its Alternative Finance Window)</p>
              <p className="mb-2">Signature:	_________________________</p>
              <p className="mb-2">Name:	_________________________</p>
              <p className="mb-6">Title:	_________________________</p>

              <p className="mb-4">Signed by the duly authorized representatives of ..............................</p>
              <p className="mb-2">Signature: _________________________</p>
              <p className="mb-2">Name: _________________________</p>
              <p className="mb-6">Title: _________________________</p>
            </div>
        </div>
      </Modal>
      <Modal
        variant="unstyled"
        openModal={openVendorChecklistModal}
        // closeModal={() => setOpenVendorChecklistModal(false)}
        style={{ position: "fixed" }}
      >
        <div
          className={styles.closeModal}
          onClick={() => setOpenVendorChecklistModal(false)}
        >
          <div className={styles.closeFlex}>
            <div className={styles.closeBox}>
              <div>
                <CloseSvg />
                <p>Close</p>
              </div>
            </div>
            <div
              className={styles.downloadBox}
              onClick={() => {
                downloadFile({
                  fileName: FileName.vendorchecklist,
                  ...downloadvalues,
                })
                  .then((res) =>
                    handleFileDownload(res.data, FileName.vendorchecklist)
                  )
                  .catch((e) => console.log(e));
              }}
            >
              <div>
                <DownloadSvg />
                <p>Download</p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.modal}>
          <div className={styles.termsfineprint}>
            <h1>Vendor Checklist</h1>
            <table>
              <thead>
                <tr>
                  <th>No</th>
                  <th>Criteria</th>
                  <th>Range</th>
                  <th>Points</th>
                  <th>Responses</th>
                </tr>
              </thead>
              <tbody>
                <tr className={styles.even}>
                  <td>General Information</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>Years Established</td>
                  <td>
                    <div className={styles.boxCell}>&#62;5</div>
                    <div className={styles.boxCell}>2-5</div>
                    <div className={styles.boxCell}>&#60;2</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>5</div>
                    <div className={styles.boxCell}>3</div>
                    <div className={styles.boxCell}>1</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.establishedYears === "5.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.establishedYears === "3.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.establishedYears === "1.00"
                        ? "Yes"
                        : "---"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Size of Firm (No of people)</td>
                  <td>
                    <div className={styles.boxCell}>&#62;5</div>
                    <div className={styles.boxCell}>10-25</div>
                    <div className={styles.boxCell}>&#60;10</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>5</div>
                    <div className={styles.boxCell}>3</div>
                    <div className={styles.boxCell}>1</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.firmSize === "5.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.firmSize === "3.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.establishedYears === "1.00"
                        ? "Yes"
                        : "---"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Annual Turnover</td>
                  <td>
                    <div className={styles.boxCell}>&#62;N500M</div>
                    <div className={styles.boxCell}>N101-N500M</div>
                    <div className={styles.boxCell}>&#60;N100</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>5</div>
                    <div className={styles.boxCell}>3</div>
                    <div className={styles.boxCell}>1</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.annualTurnover === "5.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.annualTurnover === "3.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.annualTurnover === "1.00"
                        ? "Yes"
                        : "---"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>
                    Turnover of Solar Home Systems
                    <div>as a percentage</div>
                    <div>of total annual turnover</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>&#62;80%</div>
                    <div className={styles.boxCell}>40-80%</div>
                    <div className={styles.boxCell}>&#60;40%</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>5</div>
                    <div className={styles.boxCell}>3</div>
                    <div className={styles.boxCell}>1</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>
                      {loggedInUser &&
                      loggedInUser.percentTotalAnnualTurnOver === "5.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser &&
                      loggedInUser.percentTotalAnnualTurnOver === "3.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.establishedYears === "1.00"
                        ? "Yes"
                        : "---"}
                    </div>
                  </td>
                </tr>
                <tr className={styles.even}>
                  <td>Structure & Experience</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>
                    Business Structure e.g. Joint Venture, partnership, Plc,
                    Ltd, Proprietorship etc.
                  </td>
                  <td>
                    <div className={styles.boxCell}>Excellent</div>
                    <div className={styles.boxCell}>Average</div>
                    <div className={styles.boxCell}>Poor</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>5</div>
                    <div className={styles.boxCell}>3</div>
                    <div className={styles.boxCell}>1</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.businessStructure === "5.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.businessStructure === "3.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.businessStructure === "1.00"
                        ? "Yes"
                        : "---"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>
                    Relevance of CVs of Key Engineers, experts, technicians in
                    RE
                    <div>
                      (i.e. local or international qualifications obtained)
                    </div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>Excellent</div>
                    <div className={styles.boxCell}>Average</div>
                    <div className={styles.boxCell}>Poor</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>5</div>
                    <div className={styles.boxCell}>3</div>
                    <div className={styles.boxCell}>1</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.relevanceOfCVs === "5.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.relevanceOfCVs === "3.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.relevanceOfCVs === "1.00"
                        ? "Yes"
                        : "---"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>
                    Local presences or ability to quickly
                    <div>mobilize locally in niche market</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>High</div>
                    <div className={styles.boxCell}>Average</div>
                    <div className={styles.boxCell}>Poor</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>5</div>
                    <div className={styles.boxCell}>3</div>
                    <div className={styles.boxCell}>1</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.localPresences === "5.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.localPresences === "3.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.localPresences === "1.00"
                        ? "Yes"
                        : "---"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>No of Installations done</td>
                  <td>
                    <div className={styles.boxCell}>&#62;500</div>
                    <div className={styles.boxCell}>100-499</div>
                    <div className={styles.boxCell}>&#60;100</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>5</div>
                    <div className={styles.boxCell}>3</div>
                    <div className={styles.boxCell}>1</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>
                      {loggedInUser &&
                      loggedInUser.noOfInstallationsDone === "5.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser &&
                      loggedInUser.noOfInstallationsDone === "5.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser &&
                      loggedInUser.noOfInstallationsDone === "5.00"
                        ? "Yes"
                        : "---"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>
                    Experience in Nigerian Market No of Projects &#60; 10kw
                  </td>
                  <td>
                    <div className={styles.boxCell}>&#62;6</div>
                    <div className={styles.boxCell}>3-5</div>
                    <div className={styles.boxCell}>&#60;2</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>5</div>
                    <div className={styles.boxCell}>3</div>
                    <div className={styles.boxCell}>1</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>
                      {loggedInUser &&
                      loggedInUser.experienceNigeriaMarket === "5.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser &&
                      loggedInUser.experienceNigeriaMarket === "3.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser &&
                      loggedInUser.experienceNigeriaMarket === "1.00"
                        ? "Yes"
                        : "---"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>
                    Experience with Solar Systems
                    <div>(No. of projects, size and complexity)</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>&#62;5</div>
                    <div className={styles.boxCell}>3-5</div>
                    <div className={styles.boxCell}>&#60;2</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>5</div>
                    <div className={styles.boxCell}>3</div>
                    <div className={styles.boxCell}>1</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>
                      {loggedInUser &&
                      loggedInUser.experienceSolarSystem === "5.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser &&
                      loggedInUser.experienceSolarSystem === "3.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser &&
                      loggedInUser.experienceSolarSystem === "1.00"
                        ? "Yes"
                        : "---"}
                    </div>
                  </td>
                </tr>
                <tr className={styles.even}>
                  <td>Equipment & Certifications</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>11</td>
                  <td>
                    Renewable Energy equipment design and performance
                    <div>in accordance to</div>
                    <div>
                      International Standards (IEC, DE, ISO or relevant)
                    </div>
                    <div>RE Companies which will be qualified by this EOI</div>
                    <div>must ensure that their future designs submitted</div>
                    <div>
                      for this project adhere to the standards listed here.
                    </div>
                    <div>
                      Deviating from these standards will cause disqualification
                    </div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>
                      PV Panels: At least IEC 61215 Edition and IEC 61739
                    </div>
                    <div className={styles.boxCell}>
                      Inverters: At least Harmonic Current
                      <div>(IEC 6100-3-2 and/or IEC 61000-3-4) ,</div>
                      <div>IEC 62109-1/2</div>
                    </div>
                    <div className={styles.boxCell}>
                      Batteries: At least IEC 62133, IEC 61960
                    </div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>5</div>
                    <div className={styles.boxCell}>3</div>
                    <div className={styles.boxCell}>1</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.renewableEnergy === "5.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.renewableEnergy === "3.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser && loggedInUser.renewableEnergy === "1.00"
                        ? "Yes"
                        : "---"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>Level of Warranty of Solar Solution (in years)</td>
                  <td>
                    <div className={styles.boxCell}>&#62;5</div>
                    <div className={styles.boxCell}>3-5</div>
                    <div className={styles.boxCell}>1-2</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>5</div>
                    <div className={styles.boxCell}>3</div>
                    <div className={styles.boxCell}>1</div>
                  </td>
                  <td>
                    <div className={styles.boxCell}>
                      {loggedInUser &&
                      loggedInUser.levelOfWarrantySolar === "5.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser &&
                      loggedInUser.levelOfWarrantySolar === "3.00"
                        ? "Yes"
                        : "---"}
                    </div>
                    <div className={styles.boxCell}>
                      {loggedInUser &&
                      loggedInUser.levelOfWarrantySolar === "1.00"
                        ? "Yes"
                        : "---"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td>Total Score</td>
                  <td>100</td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td>Pass Score</td>
                  <td>{loggedInUser && loggedInUser.totalVendorPercentage}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div className={styles.my4}></div>
          </div>
        </div>
      </Modal>
      <Modal
        variant="unstyled"
        openModal={openCACModal}
        // closeModal={() => setOpenCACModal(false)}
        style={{ position: "fixed" }}
      >
        <div
          className={styles.closeModal}
          onClick={() => setOpenCACModal(false)}
        >
          <div className={styles.closeFlex}>
            <div className={styles.closeBox}>
              <div>
                <CloseSvg />
                <p>Close</p>
              </div>
            </div>
            <div className={styles.downloadBox}>
              <div>
                <DownloadSvg />
                <p>Download</p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.modal}>
          <div className={styles.termsfineprint}>
            <h1>CAC</h1>

            <div className={styles.my4}></div>
          </div>
        </div>
      </Modal>
      <h2 className={styles.header}>Terms and Conditions</h2>

      <div className={styles.docFlex}>
        <div className={styles.docBoxWrapper}>
          <div className={styles.docTitle}>Memorandum of Agreement</div>
          <div
            className={styles.docMidBox}
            onClick={() => {
              setOpenMOAModal(true);
            }}
          >
            <div className={styles.docBox}>
              <SterlingLogoSvg />
              <div className={styles.docSubTitle}>Memorandum of Agreement</div>
            </div>
          </div>
          <div
            className={styles.docButton}
            onClick={() => {
              downloadFile({
                fileName: FileName.memorandum,
                ...downloadvalues,
              })
                .then((res) =>
                  handleFileDownload(res.data, FileName.memorandum)
                )
                .catch((e) => console.log(e));
            }}
          >
            <p>Download</p>
            <DownloadIconSvg />
          </div>
        </div>
        <div className={styles.docBoxWrapper}>
          <div className={styles.docTitle}>Vendor Checklist</div>
          <div
            className={styles.docMidBox}
            onClick={() => setOpenVendorChecklistModal(true)}
          >
            <div className={styles.docBox}>
              <SterlingLogoSvg />
              <div className={styles.docSubTitle}>Vendor Checklist</div>
            </div>
          </div>
          <div
            className={styles.docButton}
            onClick={() => {
              downloadFile({
                fileName: FileName.vendorchecklist,
                ...downloadvalues,
              })
                .then((res) =>
                  handleFileDownload(res.data, FileName.vendorchecklist)
                )
                .catch((e) => console.log(e));
            }}
          >
            <p>Download</p>
            <DownloadIconSvg />
          </div>
        </div>

        {(!vendorCac || !toggleCAC) && (
          <div
            className={styles.docBoxWrapperAlt}
            // onClick={() => setOpenCACModal(true)}
          >
            {!loadingInitial && vendorCac && (
              <div className={styles.toggle} onClick={() => setToggleCAC(true)}>
                <DownloadIconSvg />
              </div>
            )}
            <div className={styles.docTitle}>CAC</div>

            {(!vendorCac || !toggleCAC) && !loadingInitial && (
              <FileTemp
                src={documentUpload ? documentUpload : ""}
                children={
                  <div className={styles.docMidBoxAlt}>
                    <div className={styles.uploadFile}>
                      <DocumentFileSvg />
                      <p>Upload CAC Document</p>
                    </div>
                    <div className={styles.uploadIcon}>
                      <UploadIconSvg />
                    </div>
                  </div>
                }
                altChildren={
                  <div className={styles.docMidBoxAlt}>
                    <div className={styles.uploadFile}>
                      <DocumentFileSvg />
                      <p>{documentName}</p>
                    </div>
                    <div className={styles.uploadIcon}>
                      <UploadIconSvg />
                    </div>
                  </div>
                }
                onChange={(e) => documentHandler(e)}
                btnText=""
                accept="application/pdf"
              />
            )}
            {(!vendorCac || !toggleCAC) &&
              !loadingInitial &&
              documentUpload && (
                <div
                  className={styles.docButton}
                  onClick={() => handleCacUpload(documentUpload)}
                >
                  <p>Upload</p>
                  <UploadIconMiniSvg />
                </div>
              )}
          </div>
        )}
        {vendorCac && toggleCAC && (
          <div
            className={styles.docBoxWrapperAlt}
            // onClick={() => setOpenCACModal(true)}
          >
            {!loadingInitial && (
              <div
                className={styles.toggle}
                onClick={() => setToggleCAC(false)}
              >
                <UploadIconMiniSvg />
              </div>
            )}
            <div className={styles.docTitle}>CAC</div>
            {!loadingInitial && (
              <div className={styles.docMidBox}>
                <div className={styles.docBox}>
                  <SterlingLogoSvg />
                  <div className={styles.docSubTitle}>CAC</div>
                </div>
              </div>
            )}
            {!loadingInitial && (
              <div
                className={styles.docButton}
                onClick={() => handleFileDownload(vendorCac, FileName.cac)}
              >
                <p>Download</p>
                <DownloadIconSvg />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(TermsAndConditions);
